import React from "react";
import { Box, Flex, Text, Avatar, AvatarBadge } from "@chakra-ui/react";
//import { FaUserEdit } from "react-icons/fa"
import { useSelector } from "react-redux";
import { EditProfileModal } from "./EditProfileModal";

export const UserCard = ({ userProfile, setRefresh }) => {
  const pageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor,
  );

  return (
    <Box borderRadius={"10px"} shadow="md" bg="#fff" mb="5px">
      <Flex justifyContent="space-between" p="20px">
        <Flex
          direction={["column", "column", "row"]}
          w={["calc(100% - 60px)", "calc(100% - 60px)", "68%"]}
          minH={["auto", "auto", "170px"]}
          justifyContent="space-between"
          alignItems="center"
          color="#9B9B9B"
          gap={["16px", "16px", "0"]}
        >
          <Box>
            <Avatar
              name={userProfile?.name}
              src={userProfile?.image}
              size="2xl"
              bg={pageColor}
            >
              <AvatarBadge boxSize="0.8em" bg="green.500" />
            </Avatar>
          </Box>
          <Box textAlign={["center", "center", "left"]}>
            <Box mb="5px">
              <Text fontSize="14px" fontWeight="medium">
                Name
              </Text>
              <Text color="primary.500" fontWeight="bold" fontSize={["20px"]}>
                {userProfile?.name}
              </Text>
            </Box>
            <Box mb="5px">
              <Text fontSize="14px" fontWeight={["18px"]}>
                Phone Number
              </Text>
              <Text color="primary.500" fontWeight="semibold" fontSize={["20px"]}>
                {userProfile?.phoneNumber}
              </Text>
            </Box>
            <Box>
              <Text fontSize="14px" fontWeight="medium">
                Estate
              </Text>
              <Text color="#050509" fontWeight="semibold" fontSize="18px">
                {userProfile?.estateName}
              </Text>
            </Box>
          </Box>
        </Flex>

        <Box>
          {/* <FaUserEdit cursor="pointer" color={pageColor} size={50} /> */}
          <EditProfileModal userProfile={userProfile} setRefresh={setRefresh} />
        </Box>
      </Flex>
    </Box>
  );
};
